<template>
  <div class="login">
    <header class="header">
      <div class="top">
        <div class="left">
          <span><img src="../assets/calogo.png" alt="" /></span>
          <div class="pingtai">统一电子认证电子印章管理平台</div>
        </div>
        <div class="right">
          <div class="leval">统一电子认证电子印章管理平台</div>
          <div class="shu">|</div>
          <div class="loginOrRegist">
            <span class="regist" @click="toRegist">注册</span> /
            <span class="loginmethods">登录</span>
          </div>
        </div>
      </div>
    </header>
    <main class="main">
      <div id="mainbg">
        <div class="mainbg">
          <div class="loginInfo">
            <div class="qrImage" @click="toQR" v-if="!qrCode">
              <img src="../assets/qrCode.png" alt="" />
            </div>
            <div class="PCImage" @click="toPC" v-if="qrCode">
              <img src="../assets/pc.png" alt="" />
            </div>
            <el-tabs
              v-model="activeName"
              @tab-click="handleClick"
              stretch
              v-if="!qrCode"
            >
              <el-tab-pane label="账户密码登录" name="first">
                <el-form
                  :model="form"
                  :rules="rules"
                  ref="form"
                  class="demo-ruleForm"
                  v-if="getVer"
                >
                  <el-form-item prop="telephone">
                    <el-input
                      v-model="form.telephone"
                      placeholder="  请输入手机号"
                    >
                      <i slot="prefix" class="iconfont icon-shouji"></i
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.verCode"
                      type="text"
                      placeholder="  请点击获取验证码"
                    >
                      <i slot="prefix" class="iconfont icon-yanzhengma"></i
                      ><template slot="append"
                        ><el-button
                          type="primary"
                          class="verButtom"
                          style="
                            backgroundColor: #2850a0;
                            color: #ffffff;
                            height: 48px;
                          "
                          @click="getVerCode"
                          >{{ content }}</el-button
                        ></template
                      ></el-input
                    >
                  </el-form-item>
                </el-form>
                <el-form
                  :model="form"
                  :rules="rules"
                  ref="form"
                  class="demo-ruleForm"
                  v-else
                >
                  <el-form-item prop="userName">
                    <el-input
                      v-model="form.userName"
                      placeholder="  请输入手机号"
                    >
                      <i slot="prefix" class="iconfont icon-zhanghu"></i
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input
                      v-model="form.password"
                      type="password"
                      placeholder="  请输入登录密码"
                    >
                      <i slot="prefix" class="iconfont icon-mima"></i
                    ></el-input>
                  </el-form-item>
                </el-form>
                <div class="changeLoginMethods">
                  <div class="mima" v-if="getVer">
                    <span
                      style="color: #2850a0; cursor: pointer"
                      @click="changeVerification"
                      >密码登录</span
                    >
                  </div>
                  <div class="yanzhengma" v-else>
                    <span
                      style="color: #2850a0; cursor: pointer"
                      @click="verification"
                      >验证码登录</span
                    ><span
                      style="color: #666666; font-size: 12px; cursor: pointer"
                      @click="ForgetThePassword"
                      >忘记密码</span
                    >
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="CA登录" name="second">
                <el-form
                  :model="form"
                  :rules="rules"
                  ref="form"
                  class="demo-ruleForm"
                >
                  <el-form-item class="UK"
                    ><i class="iconfont icon-_tishi"></i>
                    <div class="UK_text">请插入UKEY，使用数字证书登录</div>
                  </el-form-item>
                  <!-- <el-form-item>
                    <el-input
                      v-model="form.name"
                      type="password"
                      placeholder="请输入UKEY密码"
                    ></el-input>
                  </el-form-item> -->
                </el-form>
              </el-tab-pane>
              <div class="loginButton">
                <el-button
                  type="primary"
                  style="width: 420px"
                  @click="ISCanLogin()"
                  >登录</el-button
                >
              </div>
              <span class="freeRegist" @click="toRegist">免费注册账户</span>
            </el-tabs>
            <div class="qrLogin" v-if="qrCode">
              <div class="appLogin">打开APP扫码登录</div>
              <div class="saoma" v-if="qrCode">
                <vue-qr
                  :bgSrc="config.imagePath"
                  :text="config.value"
                  :size="200"
                  :margin="0"
                  :correctLevel="3"
                ></vue-qr>
              </div>
              <div class="appToregist">
                还没有账号？<span class="imditra_regist" @click="toRegist"
                  >立即注册</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="companyInfo">
        <div class="contentUS">
          <div class="topOne">联系我们</div>
          <div class="toptow">
            <i class="iconfont icon-dizhi"></i>
            地址：河南省郑州市明理路平安大道博雅广场4号楼
          </div>
          <div class="toptow">
            <i class="iconfont icon-dianhua"></i>技术支持电话：0371-96596
          </div>
        </div>
        <div class="aboutUs">
          <div class="topOne">相关链接</div>
          <div class="toptow" @click="toCompany">河南省信息化发展有限公司</div>
          <div class="toptow" @click="toPri">河南省政务服务网</div>
        </div>
        <div class="downLoadApp">
          <div class="topOne">APP下载</div>
         <div class="downLoad">
          <div class="topthree">
            <div class="threespan">安卓</div>
             <el-image
                  style="width: 65px; height: 65px"
                  :src="url"
                  :preview-src-list="srcList"
                >
                </el-image>
          </div>
          <!-- <div style="width: 100%; text-align: center">敬请期待</div> -->
        </div>
        </div>
      </div>
    </main>
    <footer class="fotter">
      主办单位：河南省信息化发展有限公司
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <a
        href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
        target="_blank"
        >备案：豫ICP备14012421号-6</a
      >
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <!-- 版权所有：河南省信息化发展有限公司 -->
    </footer>
  </div>
</template>

<script>
import http from "../http";
import VueQr from "vue-qr";
import {
  XACAVerifySignData,
  init,
  GetDeviceStatus,
  GetCertInfo,
  SignData,
  GetCert,
} from "@/response/secCtrl";
import $ from "jquery";
var ALGID_AUTO = 0; // 自动识别
var ks_manager_path = "C:\\CONT\\?"; // 软证书管理员路径
var SIGN_TYPE = 2;
var pageProvider = "XACA";
var X509_CERT_SERIAL = 2; // 证书序列号
var X509_CERT_DER_PUBKEY = 22; // 证书公钥信息
export default {
  name: "Login",
  components: {
    VueQr,
  },
  data() {
    var reg1 = /^1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/;
    var checkUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("手机号不可为空"));
      } else if (!reg1.test(value)) {
        callback(new Error("手机号格式输入错误"));
      } else {
        callback();
      }
    };
    var checkUsername1 = (rule, value, callback) => {
      if (!value) {
        callback(new Error("手机号不可为空"));
      } else if (!reg1.test(value)) {
        callback(new Error("手机号格式输入错误"), (value = ""));
      } else {
        callback();
      }
    };
    //密码验证
    var reg = /^(?=.*\d+)(?=.*[A-Za-z]+)[\w]{6,18}$/;
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.telephone !== "") {
          this.$refs.form.validateField("checkPass");
        }
        if (!reg.test(value)) {
          callback(new Error("密码输入不合法"));
        }
        callback();
      }
    };
    return {
      msg: "",
      activeName: "first",
      form: {},
      getVer: false,
      qrCode: false,
        url: require("../assets/app.jpg"),
      srcList: [require("../assets/app.jpg")],
      rules: {
        telephone: [
          { validator: checkUsername1, trigger: "blur" },
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        userName: [
          { validator: checkUsername, trigger: "blur" },
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        password: [
          { validator: validatePass, trigger: "blur" },
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
      },
      timer: "",
      content: "获取验证码",
      totalTime: 60,
      canClick: true,
      config: {
        value: {}, //显示的值、跳转的地址
      },
      num: 0,
      uuid: "",
      loginType: "first",
    };
  },
  methods: {
    //切换页码
    handleClick(tab, event) {
      console.log(tab.name);
      this.loginType = tab.name;
      // console.log(tab, event);
    },
    //验证码登录
    verification() {
      this.getVer = true;
    },
    //账号密码登录
    changeVerification() {
      this.getVer = false;
    },
    //xinxihua
    toCompany() {
      window.open("https://www.hnxaca.com/");
    },
    //zhengwu
    toPri() {
      window.open(" https://www.hnzwfw.gov.cn/");
    },
    //登录
    login() {
      //账号密码登录
      if (!this.getVer) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.8)",
        });
        http.post("/login/login.shtml", this.form).then((res) => {
          let { code, data, msg } = res.data;
          if (code == 0) {
            loading.close();
            sessionStorage.setItem("userName", data.userInfo.USER_NAME);
            sessionStorage.setItem("userId", data.userInfo.ID);
            sessionStorage.setItem("userInfo", JSON.stringify(data.userInfo));
            this.updataUserRole()
            // USER_STATUS 1 未认证 2 认证
            if (data.userInfo.USER_STATUS == 1) {
              this.$router.push("/authentication");
            } else {
              this.$router.push("/main/index");
            }
          } else {
            this.$message.error(msg);
          }
        });
      } else {
        //验证码登录
        if (this.form.telephone && this.form.verCode) {
          this.checkSms();
        } else {
          this.$message.error("请输入验证码");
        }
      }
    },
    //同步数据 /user/updataUserRoleByStaffRole.shtml
    updataUserRole(){
      this.$http.post('/user/updataUserRoleByStaffRole.shtml').then(res=>{
        let {code,data,msg} = res.data
        if(code  == 0){
          sessionStorage.setItem("userInfo", JSON.stringify(data.userInfo));
        }else{
          this.$message.error(msg)
        }
      })
    },
    //判断是否可以登录
    ISCanLogin() {
      if (this.loginType == "first") {
        if (!this.getVer) {
          if (!this.form.userName) {
            this.canClickLogin = false;
            this.$message.error("请您填写手机号");
          } else if (!this.form.password) {
            this.$message.error("请您填写密码");
          } else {
            this.canClickLogin = true;
            this.login();
          }
        } else {
          this.login();
        }
      } else {
        init(pageProvider, ALGID_AUTO, ks_manager_path);
        var cert = GetCert(SIGN_TYPE);
        if (cert == "") {
          alert("获取证书序失败");
          return false;
        } else {
          var certsn = GetCertInfo(cert, X509_CERT_SERIAL);
          var signData = SignData(certsn, ALGID_AUTO, certsn);
          http
            .post("/login/ukeyLogin.shtml", { signCert: cert })
            .then((res) => {
              let { code, data, msg } = res.data;
              if (code == 0) {
                sessionStorage.setItem("userName", data.userInfo.USER_NAME);
                sessionStorage.setItem("userId", data.userInfo.ID);
                sessionStorage.setItem(
                  "userInfo",
                  JSON.stringify(data.userInfo)
                );
                if (data.userInfo.USER_STATUS == 1) {
                  this.$router.push("/authentication");
                } else {
                  this.$router.push("/main/index");
                }
              } else {
                this.$message.error(msg);
              }
            });
        }
      }
    },
    //注册
    toRegist() {
      this.$router.push("/regist");
    },
    //获取验证码
    getVerCode() {
      if (this.form.telephone) {
        if (!this.canClick) return;
        let param = {
          type: "1",
          telephone: this.form.telephone,
        };
        http.post("sms/sendSms.shtml", param).then((res) => {
          let { code, data, msg } = res.data;
          if (code == 0) {
            this.canClick = false;
            this.content = this.totalTime + "s后重新发送";
            let clock = window.setInterval(() => {
              this.totalTime--;
              this.content = this.totalTime + "s后重新发送";
              if (this.totalTime < 0) {
                window.clearInterval(clock);
                this.content = "重新发送验证码";
                this.totalTime = 60;
                this.canClick = true; //这里重新开启
              }
            }, 1000);
            localStorage.setItem("token", data.token);
          } else {
            this.$message.error(msg);
          }
        });
      } else {
        this.$message.error("请输入手机号");
      }
    },
    //验证验证码 /sms/checkSms.shtml
    checkSms() {
      let param = {
        telephone: this.form.telephone,
        verCode: this.form.verCode,
      };
      this.$http.post("/sms/checkSms.shtml", param).then((res) => {
        let { code, data, msg } = res.data;
        if (code == 0) {
          this.loginByPhoneNum();
        } else {
          this.$message.error(msg);
        }
      });
    },
    //验证码登录
    loginByPhoneNum() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)",
      });
      let param = {
        telephone: this.form.telephone,
        verCode: this.form.verCode,
      };
      http.post("/login/loginByPhoneNum.shtml", param).then((res) => {
        let { code, data, msg } = res.data;
        if (code == 0) {
          loading.close();
          sessionStorage.setItem("userName", data.userInfo.USER_NAME);
          sessionStorage.setItem("userId", data.userInfo.ID);
          sessionStorage.setItem("userInfo", JSON.stringify(data.userInfo));
           this.updataUserRole()
          // USER_STATUS 1 未认证 2 认证
          if (data.userInfo.USER_STATUS == 1) {
            this.$router.push("/authentication");
          } else {
            this.$router.push("/main/index");
          }
        } else {
          this.$message.error(msg);
        }
      });
    },
    //忘记密码
    ForgetThePassword() {
      this.$router.push("/regist/resetpassword");
    },
    //监听回车按钮事件
    watchEnter(e) {
      var keyNum = window.event ? e.keyCode : e.which; //获取被按下的键值
      //判断如果用户按下了回车键（keycody=13）
      if (keyNum == 13) {
        this.login("ruleForm");
      }
    },
    //获取扫码登录信息
    // /login/scanQrcode.shtml
    scanQrcode() {
      this.$http.post("/login/scanQrcode.shtml").then((res) => {
        let { code, data, msg } = res.data;
        if (code == 0) {
          this.config.value = JSON.stringify(data.qRcodeInfo);
          this.uuid = data.uuid;
          var timesRun = 0;
          this.timer = setInterval(() => {
            timesRun += 1;
            if (timesRun > 5) {
              clearInterval(this.timer);
              this.timer = null;
            } else {
              this.checkScanLoginStatus();
            }
          }, 3000);
        } else {
          this.$message.error(msg);
          loading.close();
        }
      });
    },
    //轮循 查询扫码登录状态 /login/checkScanLoginStatus.shtml
    checkScanLoginStatus() {
      let param = {
        uuid: this.uuid,
      };
      this.$http
        .post("/login/checkScanLoginStatus.shtml", param)
        .then((res) => {
          let { code, data, msg } = res.data;
          if (code == 0) {
            clearInterval(this.timer);
            this.timer = null;
            sessionStorage.setItem("userName", data.userInfo.USER_NAME);
            sessionStorage.setItem("userId", data.userInfo.ID);
            sessionStorage.setItem("userInfo", JSON.stringify(data.userInfo));
             this.updataUserRole()
            if (data.userInfo.USER_STATUS == 1) {
              this.$router.push("/authentication");
            } else {
              this.$router.push("/main/index");
            }
          } else {
          }
        });
    },
    //扫码登录
    toQR() {
      this.qrCode = true;
      this.scanQrcode();
    },
    //PC 端登录
    toPC() {
      this.qrCode = false;
      clearInterval(this.timer);
      this.timer = null;
    },
  },
  created() {
    var _this = this;
    document.addEventListener("keydown", _this.watchEnter);
  },
  mounted() {
    // console.log($)
  },
  beforeDestroy() {
    clearInterval(this.timer);
    window.clearInterval(clock);
    this.timer = null;
  },
  destroyed() {
    //移除监听回车按键
    var _this = this;
    document.removeEventListener("keydown", _this.watchEnter);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
  margin: 0;
  padding: 0;
  background-color: #ffffff;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.header {
  height: 0.101652%vh;
  background-color: white;
}
.top {
  width: 1110px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.saoma {
  padding: 10px;
  background: #ffffff;
}
.left {
  font-family: MicrosoftYaHei-Bold;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #333333;
  display: flex;
}
.pingtai {
  margin-left: 8px;
  line-height: 108px;
}
.right {
  display: flex;
  font-size: 18px;
  font-family: MicrosoftYaHei;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #666666;
}
.regist {
  cursor: pointer;
}
.loginmethods {
  cursor: pointer;
  color: #2850a0;
  font-weight: 800;
}
.shu {
  height: 18px;
  width: 1px;
  color: #666666;
  padding: 0 20px;
}
span > img {
  height: 70px;
  width: 94px;
  margin-top: 25px;
}
.main {
  color: #333;
  /* flex: 1; */
  /* height: 90vh; */
  width: 100%;
}
#mainbg {
  background-image: url("../assets/bg.png");
  background-repeat: no-repeat center center;
  border: none;
  background-size: cover;
  /* height: 690px; */
}
.mainbg {
  margin: 0 auto;
  width: 1110px;
  height: 637px;
  overflow: hidden;
}
.el-header {
  height: 0.101652%vh;
  background-color: #ffffff;
}
.loginInfo {
  width: 550px;
  height: 420px;
  background-color: #ffffff;
  box-shadow: 0px 7px 27px 0px rgba(133, 169, 231, 0.51);
  border-radius: 6px;
  margin-bottom: 185px;
  margin-top: 85px;
}
.qrImage {
  position: absolute;
  margin-left: 450px;
  margin-top: -18px;
}
.PCImage {
  position: absolute;
  margin-left: 450px;
  margin-top: -17px;
}
.el-tabs {
  width: 420px;
  height: 351px;
  margin-left: 65px;
  padding-top: 38px;
}
.fotter {
  height: 36px;
  background-color: #cccccc;
  text-align: center;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
  line-height: 36px;
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
  z-index: 999;
}
.el-tabs >>> .el-tabs__content {
  padding-top: 28px;
}
.el-input--prefix >>> .el-input__prefix {
  line-height: 48px;
}
.el-input--prefix >>> .el-input__inner {
  padding-left: 30px;
  height: 48px;
  border: none;
  line-height: 48px;
  border-bottom: 1px solid #cccccc;
}
.el-input__inner {
  height: 48px;
  border: none;
  border-bottom: 1px solid #cccccc;
}
.el-tab-pane {
  margin-top: -30px;
  margin-bottom: 33px;
  height: 150px;
}
.yanzhengma {
  display: flex;
  justify-content: space-between;
  margin-top: 27px;
}
.mima {
  margin-top: 27px;
}
.loginButton {
  margin-bottom: 21px;
}
.freeRegist {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #666666;
  padding-top: 21px;
  margin-left: 320px;
  cursor: pointer;
}
.qrLogin {
  width: 220px;
  height: 300px;
  margin: auto;
  padding-top: 56px;
}
.appLogin {
  text-align: center;
  margin-bottom: 43px;
}
.appToregist {
  margin-top: 30px;
  cursor: pointer;
}
.imditra_regist {
  color: #5670ae;
}
.companyInfo {
  display: flex;
  justify-content: space-between;
  width: 1110px;
  margin: 0 auto;
  margin-bottom: 48px;
  margin-top: 20px;
}
.contentUS {
  width: 400px;
  height: 110px;
  background-color: #f5f5f5;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}
.aboutUs {
  width: 368px;
  height: 110px;
  background-color: #f5f5f5;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}
.downLoadApp {
  width: 296px;
  height: 110px;
  background-color: #f5f5f5;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
}
.downLoad {
  display: flex;
}
.topOne {
  margin: 10px 0px 14px 10px;
}
.toptow {
  margin: 10px 0px 16px 10px;
  height: 22px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.topthree {
  display: flex;
  width: 113px;
  overflow: hidden;
  margin: auto 65px;
}
.threespan {
  margin: 32px 8px 0px 0px;
}
.iconfont {
  font-size: 24px;
  padding-top: 5px;
}
.el-tabs >>> .el-tabs__item.is-active {
  color: #2850a0;
}
.el-tabs >>> .el-tabs__item {
  border: none !important;
}
.el-tabs >>> .el-tabs__item:hover {
  color: #2850a0;
}
.el-tabs >>> .el-tabs__active-bar {
  background-color: #2850a0;
}
.el-tabs >>> .el-tabs__nav-wrap::after {
  height: 0;
}
.el-tabs >>> .el-tabs__nav-scroll {
  width: 471px;
  margin: auto;
  margin-bottom: 34px;
}
</style>



// WEBPACK FOOTER //
// src/login/Login.vue